import { createRouter, createWebHistory } from '@ionic/vue-router';
import MainTabs from '@/views/MainTabs.vue';
import Home from '@/views/Home.vue';
import loggedInMiddleware from '@/middleware/loggedIn';
import redirectToHomeMiddleware from '@/middleware/redirect-to-home';
import redirectToCompleteProfileMiddleware from '@/middleware/redirect-to-complete-profile';

/**
 * @info meta.player - defined if player is available in route
 **/

const routes = [
  {
    path: '/',
    redirect: '/main/home',
  },

  {
    path: '/main/',
    name: 'MainTabs',
    component: MainTabs,
    children: [
      {
        path: '',
        name: 'MainTabsDefault',
        redirect: '/main/home',
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: 'following',
        name: 'Following',
        component: () =>
          import(/* webpackChunkName: "following" */ '@/views/Following.vue'),
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: 'search',
        name: 'Search',
        component: () =>
          import(/* webpackChunkName: "search" */ '@/views/Search.vue'),
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: '/company/:companyId',
        name: 'Company',
        component: () =>
          import(/* webpackChunkName: "company" */ '@/views/Company.vue'),
        meta: {
          auth: true,
          player: true,
        },
      },
      {
        path: '/course/:courseId',
        name: 'PublicPodcastSeries',
        component: () =>
          import(
            /* webpackChunkName: "podcast-series" */ '@/views/PublicPodcastSeries.vue'
          ),
        meta: {
          player: true,
          dynamicColors: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    beforeEnter: loggedInMiddleware,
  },
  {
    path: '/switch-application',
    name: 'SwitchApp',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/auth/SwitchApp.vue'),
  },
  {
    path: '/applications-list',
    name: 'ApplicationsList',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/ApplicationsList.vue'),
  },
  {
    path: '/select-profession',
    name: 'SelectProfession',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/views/auth/SelectProfession.vue'
      ),
    beforeEnter: [
      redirectToHomeMiddleware,
      redirectToCompleteProfileMiddleware,
    ],
  },
  {
    path: '/complete-profile',
    name: 'CompleteProfile',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/views/auth/CompleteProfile.vue'
      ),
    beforeEnter: redirectToHomeMiddleware,
  },
  {
    path: '/sign-up',
    name: 'Sign-up',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/views/auth/SignUp.vue'),
    beforeEnter: loggedInMiddleware,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ '@/views/auth/ForgotPassword.vue'
      ),
    meta: {
      auth: false,
    },
  },
  {
    path: '/forgot-email',
    name: 'ForgotEmail',
    component: () =>
      import(
        /* webpackChunkName: "forgot-email" */ '@/views/auth/ForgotEmail.vue'
      ),
    meta: {
      auth: false,
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Contact.vue'),
    meta: {
      player: true,
    },
  },
  {
    path: '/continue-watching',
    name: 'ContinueWatching',
    component: () =>
      import(
        /* webpackChunkName: "continue-watching" */ '@/views/ContinueWatching.vue'
      ),
    meta: {
      auth: true,
      player: true,
    },
  },
  {
    path: '/invite/:inviteToken',
    name: 'DownloadApp',
    component: () =>
      import(/* webpackChunkName: "download-app" */ '@/views/DownloadApp.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
